module.exports = __webpack_public_path__ + "assets/img/loyalty-2.2b3f2794.svg";